import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Paper,
  List,
  ListItem,
  ListItemText,
  TextField,
  Button,
  Avatar,
  Stack,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

import { getImageV3 } from "../utils/images";
import { brand, gray } from "../getLPTheme";
import _ from "lodash";

const Chat = ({ messages, addMessage, specialistId }) => {
  const [input, setInput] = useState("");
  const bottomRef = useRef(null);
  const containerRef = useRef(null);
  const itemRefs = useRef(new Map());
  const isFirstRender = useRef(true);

  const setItemRef = (message, index) => (el) => {
    if (index === messages.length - 1) {
      bottomRef.current = el;
    }
    if (el) {
      itemRefs.current.set(message.id, el);
    } else {
      itemRefs.current.delete(message.id);
    }
  };

  const isInView = (el) => {
    const container = containerRef.current;
    if (!el || !container) return false;
    const elRect = el.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();
    return elRect.top >= cRect.top && elRect.bottom <= cRect.bottom;
  };

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    if (isFirstRender.current) {
      isFirstRender.current = false;
      container.scrollTop = container.scrollHeight;
      return;
    }
    const last = messages[messages.length - 1];
    if (!last) return;
    const prev = messages[messages.length - 2];
    const prevWasVisible = prev
      ? isInView(itemRefs.current.get(prev.id))
      : false;
    if (last?.specialist?.id === specialistId || prevWasVisible) {
      bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  const handleSend = () => {
    if (input.trim()) {
      addMessage(input);
      setInput("");
    }
  };

  const getAuthor = (message) => {
    if (message?.specialist) {
      return message?.specialist;
    }

    if (message?.client) {
      return message?.client;
    }

    if (message?.admin) {
      return message?.admin;
    }

    return null;
  };

  return (
    // <Paper elevation={0} sx={{ height: 400, display: 'flex', flexDirection: 'column' }}>
    <Box
      sx={{
        height: "100%",
        fontSize: "12px",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
      }}
    >
      {/* Message List Area */}
      <Box
        sx={{ flexGrow: 1, overflowY: "auto", padding: 2, minHeight: 0 }}
        ref={containerRef}
      >
        <List>
          {messages.map((message, index) => (
            <ListItem
              key={message.id}
              ref={setItemRef(message, index)}
              sx={{
                justifyContent:
                  message?.specialist?.id === specialistId
                    ? "flex-end"
                    : "flex-start",
              }}
            >
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{
                  justifyContent:
                    message?.specialist?.id === specialistId
                      ? "flex-end"
                      : "flex-start",
                }}
              >
                {message?.specialist?.id !== specialistId ? (
                  <Avatar
                    src={getImageV3(
                      _.nth(
                        getAuthor(message)?.images?.map((im) => im?.id),
                        0,
                      ),
                    )}
                  />
                ) : null}
                <Box
                  sx={{
                    padding: 1.5,
                    fontSize: "10px",
                    borderRadius: "20px",
                    bgcolor:
                      message?.specialist?.id === specialistId
                        ? brand[100]
                        : "grey.100",
                    color: "black",
                    maxWidth: "70%",
                  }}
                >
                  <ListItemText
                    primary={message.text}
                    sx={{
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                      whiteSpace: "pre-wrap",
                      m: 0,
                    }}
                  />
                </Box>
              </Stack>
            </ListItem>
          ))}
        </List>
      </Box>

      {/* Input Area */}
      <Box
        sx={{
          p: 1,
          flexShrink: 0,
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          sx={{ justifyContent: "center", alignItems: "center" }}
        >
          {/*  occupies all the container */}
          <Box sx={{ flexGrow: 1 }}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Сообщение"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleSend()}
            />
          </Box>
          {/*  occupies only what is left the container */}
          <Box sx={{ flexShrink: 0 }}>
            <Button variant={"contained"}>
              <ArrowUpwardIcon
                fontSize={"medium"}
                sx={{ fontWeight: "300" }}
                onClick={handleSend}
              ></ArrowUpwardIcon>
            </Button>
          </Box>
          {/*<Button variant="contained" color="primary" onClick={handleSend}>*/}
          {/*    Send */}
          {/*</Button>*/}
        </Stack>
      </Box>
    </Box>
    // </Paper>
  );
};

export default Chat;
